import { InspectionNode } from "inspector-common/lib/model";

export function canDropF(item: {identifier: number[]}, monitor: any, identifier: number[]) {
    return item.identifier.toString() !== identifier.toString() && 
    !(identifier.slice(0, item.identifier.length).toString() === item.identifier.toString()) &&
    monitor.isOver({shallow: true})
}

export function getMoveIndex(node: InspectionNode, identifier: number[], monitor: any) {
    let index = 0;
    node.children.forEach((child, childIndex) => {
        const childID = identifier.concat(childIndex);
        const childY = document.getElementById(`template-node-${childID.toString()}`);
        const offset = monitor.getClientOffset();
        const childOffset = childY?.getBoundingClientRect();

        if (offset && childOffset) {
            if (offset.y > childOffset.top) {
                index++;
            }
        }
    });
    return index;
}
